import { SETUP_CHAT_PURPOSE } from '@zerohuman/shared'
import type { LocationQueryValue, Router } from 'vue-router'
import { api } from '@/api'

/**
 * The setup conversation a guided screen was opened from (`?chat=<id>`), so the way back is that same conversation.
 * Null when the screen was opened another way: a direct link, a bookmark, or the assembly's own link.
 */
export function setupChatFrom(chat: LocationQueryValue | LocationQueryValue[] | undefined): string | null {
    return typeof chat === 'string' && chat ? chat : null
}

/**
 * "Set up with your COO instead" (#1742, #2154): setup moves back to the chat path, and the setup conversation opens
 * at the same step. That is `fromChat`, the conversation the person came from, when there is one; else a setup
 * conversation is opened first.
 *
 * The guided shell and the standalone team-setup screen both leave this way, so the way back is the same wherever it
 * is drawn. A refusal is thrown for the caller to word.
 */
export async function backToSetupChat(router: Router, fromChat: string | null): Promise<void> {
    const chatId = fromChat ?? (await api.openChatForPurpose(SETUP_CHAT_PURPOSE)).id
    await api.switchOnboardingPath('chat', chatId)
    await router.push(`/chat/${chatId}`)
}
